// Environment Configuration - Secure
// This file should be used instead of hardcoded values in apiClient.ts
// Uses LITERAL process.env access so Webpack DefinePlugin can replace values at build time

interface EnvironmentConfig {
  REACT_APP_SUPABASE_URL: string;
  REACT_APP_SUPABASE_KEY: string;
  REACT_APP_API_BASE_URL: string;
  NODE_ENV: string;
  IS_PRODUCTION: boolean;
  IS_DEVELOPMENT: boolean;
}

// NOTE: We MUST use literal string access (process.env.VAR_NAME) 
// instead of dynamic access (process.env[key]) so Webpack's DefinePlugin 
// can replace these at build time for S3 deployment
export const config: EnvironmentConfig = {
  REACT_APP_SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL || '',
  REACT_APP_SUPABASE_KEY: process.env.REACT_APP_SUPABASE_KEY || '',
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '',
  NODE_ENV: process.env.NODE_ENV || 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  IS_DEVELOPMENT: process.env.NODE_ENV !== 'production'
};

// Validation - only runs in development
const validateConfig = (): void => {
  const missing: string[] = [];

  if (!config.REACT_APP_SUPABASE_URL) {
    missing.push('REACT_APP_SUPABASE_URL');
  }
  if (!config.REACT_APP_SUPABASE_KEY) {
    missing.push('REACT_APP_SUPABASE_KEY');
  }

  if (missing.length > 0) {
    console.error('❌ Missing required environment variables:', missing);
    console.error('Please set these in your .env file');
  }
};

// Run validation in development
if (config.IS_DEVELOPMENT) {
  validateConfig();
}

export default config; 